module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2019_09.80a96c51.jpg";